// extracted by mini-css-extract-plugin
module.exports = {"card":"GlobalMenuCard_card__I_wHb","image":"GlobalMenuCard_image__ZKiSU"};